import React, { useState, useEffect } from 'react';
import { Background, Container, Table, RemoveIcon, EditIcon, AnexoIcon, ShowIcon, PdfIcon, Filters, Button, ScrollTable, Title } from './style';
import api from '../../../services/api';
import InputLabel from '../../../components/InputLabel';
import ModalRegister from '../../../components/Modal/Gestor/RegisterProcesso';
import ModalEdit from '../../../components/Modal/Gestor/EditProcesso';
import { useNavigate } from 'react-router-dom';
import { Swal } from '../../../services/SwalTemplates';
import { add, format, difference } from '../../../services/DateFormatter';
import { TruncateString } from '../../../services/TruncateString';
import Pagination from '../../../components/Pagination';
import { userId } from '../../../services/TokenData';
import alert from '../../../utils/alert';

export default function Dashboard() {
    const [Dados, setDados] = useState([]);
    const [Search, setSearch] = useState('');
    const [DataInicio, setDataInicio] = useState('');
    const [DataFim, setDataFim] = useState('');
    const [ShowModalRegister, setShowModalRegister] = useState(false);
    const [ShowModalEdit, setShowModalEdit] = useState(false);
    const [DadosEdit, setDadosEdit] = useState('');
    const [Page, setPage] = useState(0);
    const [Reload, setReload] = useState(false);
    const Navigate = useNavigate();
    const Limit = 8;

    useEffect(() => {
        api.get(`/processos?assunto=${Search}&data_inicio=${DataInicio}&data_fim=${DataFim}&page=${Page}&limit=${Limit}&id_usuario=${userId()}`).then((response) => {
            setDados(response?.data?.processos);
        });
    }, [DataInicio, DataFim, Search, Reload, Page]);

    function deletaProcesso(id, processo, id_usuario) {
        Swal.fire({
            title: `Deseja excluir o processo ${processo}?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: 'var(--deep-carmine-pink)',
            cancelButtonColor: 'gray',
            confirmButtonText: 'DELETAR',
            cancelButtonText: 'CANCELAR',
        }).then((result) => {
            if (result.isConfirmed) {
                api.delete(`/processos/${id}/${id_usuario}`).then((res) => {
                    alert('Sucesso-popup', 'Processo deletado com sucesso!', 3000, '', '', 'top-end', 'fit-content');
                    setReload((prev) => !prev);
                });
            }
        });
    }

    function AlertaCor(dados) {
        if (dados?.situacao === 'Cancelado') {
            return 'C';
        } else if (dados?.situacao === 'Concluído') {
            return 'G';
        } else {
            const diferenca = difference({
                DataInicial_1: Date(),
                DataInicial_2: dados?.data_prevista,
            });

            if (new Date(format({ DataInicial: dados?.data_prevista, Formato: 'YYYY/MM/DD' })) < new Date()) {
                return 'V';
            }

            return diferenca <= dados?.dias_para_vermelho ? 'V' : diferenca <= dados?.dias_para_amarelo ? 'A' : '';
        }
    }

    return (
        <Background>
            <Container>
                <Title>
                    <h1>Lista de Processos</h1>
                </Title>
                <Filters>
                    <Button onClick={() => setShowModalRegister(true)}>Novo</Button>
                    <InputLabel
                        type="search"
                        value={Search}
                        onChange={(e) => {
                            setSearch(e.target.value);
                            setPage(0);
                        }}
                        label="Buscar"
                    />
                    <InputLabel type="date" value={DataInicio} onChange={(e) => setDataInicio(e.target.value)} label="Data Início" />
                    <InputLabel type="date" value={DataFim} onChange={(e) => setDataFim(e.target.value)} label="Data Fim" />
                </Filters>
                <ScrollTable>
                    <Table>
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Número</th>
                                <th></th>
                                <th>Assunto</th>
                                <th>Entrada</th>
                                <th>Responsável</th>
                                <th>Situação</th>
                                <th>Data Início</th>
                                <th>Data Prevista</th>
                                <th>Dias Restantes</th>
                                <th>Data Conclusão</th>
                                <th>Duração (dias)</th>
                                <th>Data Espera</th>
                                <th></th>
                                <th></th>
                                <th></th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {Dados?.map((d, i) => (
                                <tr key={i}>
                                    <td>{d?.id}</td>
                                    <td className={AlertaCor(d)}> {d?.numero}</td>
                                    <td>{d?.anexos === 0 || <AnexoIcon title={`${d?.anexos} ${d?.anexos === 1 ? 'anexo' : 'anexos'}`} />}</td>
                                    <td title={d?.assunto}>{TruncateString(d?.assunto, 20)}</td>
                                    <td>
                                        {format({
                                            DataInicial: d?.data_entrada,
                                            Formato: 'DD/MM/YYYY',
                                        }) || '-'}
                                    </td>
                                    <td title={d?.responsavel_nome}>{TruncateString(d?.responsavel_nome, 10)}</td>
                                    <td>{d?.situacao}</td>
                                    <td>
                                        {format({
                                            DataInicial: d?.data_inicio,
                                            Formato: 'DD/MM/YYYY',
                                        }) || '-'}
                                    </td>
                                    <td>
                                        {format({
                                            DataInicial: new Date(d?.data_prevista),
                                            Formato: 'DD/MM/YYYY',
                                        })}
                                    </td>
                                    <td>
                                        {difference({
                                            DataInicial_2: d?.data_prevista,
                                            DataInicial_1: Date(),
                                        }) || '0'}
                                    </td>
                                    <td>
                                        {format({
                                            DataInicial: d?.data_conclusao + "T00:00:00",
                                            Formato: 'DD/MM/YYYY',
                                        }) || '-'}
                                    </td>
                                    <td>
                                        {d?.data_conclusao
                                            ? difference({
                                                  DataInicial_1: new Date(d?.data_inicio),
                                                  DataInicial_2: new Date(d?.data_conclusao),
                                              })
                                            : '-'}
                                    </td>
                                    <td>
                                        {format({
                                            DataInicial: d?.data_espera,
                                            Formato: 'DD/MM/YYYY',
                                        }) || '-'}
                                    </td>
                                    <td>
                                        <ShowIcon
                                            title="Ver Processo"
                                            onClick={() =>
                                                Navigate('/gestor/processo', {
                                                    state: {
                                                        IdOcorrencia: d?.id,
                                                        IdResponsavel: d?.responsavel,
                                                        NumProcesso: d?.numero,
                                                    },
                                                })
                                            }
                                        />
                                    </td>
                                    <td>
                                        <PdfIcon
                                            title="PDF"
                                            onClick={() =>
                                                Navigate('/ocorrenciapdf', {
                                                    state: { Id_processo: d?.id },
                                                })
                                            }
                                        />
                                    </td>
                                    <td>
                                        <EditIcon
                                            title="Editar"
                                            onClick={() => {
                                                setDadosEdit(d);
                                                setShowModalEdit(true);
                                            }}
                                        />
                                    </td>
                                    <td>
                                        <RemoveIcon
                                            title="Excluir"
                                            onClick={() => {
                                                deletaProcesso(d?.id, d?.numero, userId());
                                            }}
                                        />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </ScrollTable>
                <Pagination Page={Page} setPage={setPage} Limit={Limit} Count={Dados[0]?.count} />
            </Container>
            <ModalRegister Show={ShowModalRegister} setShow={setShowModalRegister} setReload={setReload} Reload={Reload} />
            <ModalEdit Show={ShowModalEdit} setShow={setShowModalEdit} Dados={DadosEdit} setReload={setReload} Reload={Reload} />
        </Background>
    );
}
